import React, { useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useLookupModule from '../../../../hooks/Lookups/use-Lookup-Module';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
 import Loading from '../../../../components/Shared/Loader/Loading';
import useGetDashboardsList from '../../../../hooks/NTX/useGetDashboardsList';
import { usePermissions } from '../../../../Helper/Permisstions/usePermissions';
import NtxTable from '../../../../components/DataTable/NtxTable';

const Index = () => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const [search, setSearch] = useState<string>('');

  const Navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState(null);
  const { Module } = useLookupModule();
  //___________________________________________س_______

  const { DashBoardList, loading, error } = useGetDashboardsList();

  //_________________________________________________________________________________________________

  const filteredSearch = DashBoardList?.slice()
    ?.filter((item) => {
      const searchLowerCase = search.toLowerCase();
      return (
        item.name?.toLowerCase().includes(searchLowerCase) ||
        item.name2?.toLowerCase().toString().includes(searchLowerCase)
      );
    })
    ?.filter((f) => (selectedValue === null ? true : f.moduleId === selectedValue));

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('Application'), key: 'Application' },
    { title: t(''), key: 'action', className: 'text-end' },
  ];

  const tableData = filteredSearch?.map((item) => {
    let rowClass;
    const module = Module?.find((f: { id: string }) => f?.id === item?.moduleId);

    return {
      Name: i18n.language === 'ar' ? item.name2 : item.name,
      Application: module ? (i18n.language === 'en' ? module.name : module.name2) : '',
      action: (
        <>
          {HasPermission('NtxEditDashboard') && (
            <button
              type="button"
              className="btn btn-outline-theme"
              onClick={() => Navigate(`${item.id}/UpdateDashBoard`)}>
              <i className="far fa-lg fa-fw me-2 fa-edit"></i>
              {t('Edit')}
            </button>
          )}
        </>
      ),

      rowClass, // استخدم rowClass هنا
    };
  });

  //____________________________
  var BcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: t('DashboardManagement'),
      link: null,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <Breadcrumb BreadcrumbList={BcrumbList} PageName={t('DashboardManagement')} />
        {HasPermission('NtxAddDashboard') && (
          <div className="ms-auto">
            <button
              className="btn btn-theme"
              onClick={() => Navigate(`/NtxDashboardManagement/AddUpdate`)}>
              <i className="fa fa-plus-circle fa-fw me-1"></i>
              {t('AddNewDashboard')}
            </button>
          </div>
        )}
      </div>

      <Card>
        <Loading loading={loading} error={error}>
          <CardBody>
            <div className="row">
              <div className="col-xl-6">
                <div className="input-group flex-nowrap mb-2">
                  <span className="input-group-text">{t('Application')}</span>
                  <Select
                    classNamePrefix="react-select"
                    className="w-100"
                    isSearchable={true}
                    isClearable
                    options={
                      Module &&
                      Module?.map((item: any) => ({
                        value: item.id,
                        label: i18n.language === 'ar' ? item.name2 : item.name,
                      }))
                    }
                    onChange={(option: any) => {
                      setSelectedValue(option === null ? null : option.value);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>
              <div className="col-xl-6">
                <div className="input-group flex-nowrap mb-2">
                  <span className="input-group-text">{t('Search')}</span>
                  <input
                    type="text"
                    autoComplete="off"
                    className="form-control "
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>

            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=""
              tableClass="table text-nowrap table-hover "
            />
          </CardBody>
        </Loading>
      </Card>
    </>
  );
};

export default Index;
